// Static culture & etiquette data per destination — 100% offline
// Covers: lexique, tipping, customs, nature rules
import { detectCountry } from "./emergencyData";

const CULTURE_DATA = {

  // ── NAMIBIE ────────────────────────────────────────────────────────────────
  NAMIBIA: {
    flag: "🇳🇦",
    currency: "NAD",
    lexique: [
      { word: "Hallo", translation: "Bonjour", phonetic: "Hah-lo", lang: "Afrikaans / Anglais" },
      { word: "Asseblief", translation: "S'il vous plaît", phonetic: "Ah-suh-bleef", lang: "Afrikaans" },
      { word: "Dankie", translation: "Merci", phonetic: "Dahn-kee", lang: "Afrikaans" },
      { word: "Totsiens", translation: "Au revoir", phonetic: "Tot-seens", lang: "Afrikaans" },
      { word: "Hoeveel kos dit?", translation: "Combien ça coûte ?", phonetic: "Hoo-feel-koss-dit", lang: "Afrikaans" },
    ],
    pourboires: [
      { service: "Garde de parking", amount: "5–10 NAD", note: "Monnaie locale toujours appréciée" },
      { service: "Guide de safari", amount: "100–200 NAD / jour", note: "Par guide, chaque jour d'excursion" },
      { service: "Restaurant", amount: "10 %", note: "Si service non inclus" },
      { service: "Porteur d'hôtel", amount: "20–30 NAD", note: "Par bagage" },
      { service: "Chauffeur privé", amount: "50–100 NAD / jour", note: "Pour les longues sorties" },
    ],
    coutumes: [
      "Toujours saluer avec un 'Hello, how are you?' avant toute demande — c'est une règle d'or namibienne.",
      "Demander l'autorisation explicitement avant de photographier des personnes, en particulier dans les villages Himba.",
      "Ne pas offrir d'argent ou de cadeaux aux Himba sans y avoir été invité — cela peut être mal perçu.",
      "Les poignées de main sont la norme pour les hommes. Attendre que la femme tende la main en premier.",
      "L'heure namibienne est souple : prévoir 15 à 30 minutes de marge sur tout rendez-vous informel.",
    ],
    nature: [
      "Interdiction absolue de rouler hors des pistes balisées — les sols désertiques mettent des décennies à se régénérer.",
      "Ne jamais nourrir les animaux sauvages (jacals, babouins, oiseaux) — cela crée une dépendance et des comportements dangereux.",
      "Rapporter tous vos déchets des parcs nationaux (Leave No Trace) — les poubelles sont absentes sur les pistes.",
      "Respecter les distances de sécurité avec la faune : rester dans le véhicule lors des safaris, moteur éteint.",
      "Ne jamais ramasser pierres, fossiles ou plantes dans les réserves — c'est illégal et pénalisé.",
    ],
  },

  // ── MAURICE ────────────────────────────────────────────────────────────────
  MAURITIUS: {
    flag: "🇲🇺",
    currency: "MUR",
    lexique: [
      { word: "Bonzour", translation: "Bonjour", phonetic: "Bon-joor", lang: "Créole mauricien" },
      { word: "S'il vous pli", translation: "S'il vous plaît", phonetic: "Seel-voo-plee", lang: "Créole mauricien" },
      { word: "Mersi", translation: "Merci", phonetic: "Mair-see", lang: "Créole mauricien" },
      { word: "Salam", translation: "Salut (informel)", phonetic: "Sah-lam", lang: "Créole mauricien" },
      { word: "Kombien sa ?", translation: "Combien ça coûte ?", phonetic: "Kom-byan-sah", lang: "Créole mauricien" },
    ],
    pourboires: [
      { service: "Restaurant", amount: "5–10 %", note: "Optionnel, pour un service remarqué" },
      { service: "Chauffeur / Guide", amount: "200–500 MUR / jour", note: "Selon la durée et la qualité" },
      { service: "Excursion plongée", amount: "100–200 MUR", note: "Par instructeur, après la sortie" },
      { service: "Personnel d'hôtel", amount: "50–100 MUR", note: "Pour des services particuliers" },
      { service: "Taxi", amount: "Non obligatoire", note: "Arrondir à la dizaine supérieure" },
    ],
    coutumes: [
      "Retirer ses chaussures et couvrir épaules et genoux avant d'entrer dans un temple hindou ou une mosquée.",
      "Ne jamais pointer une divinité, une statue religieuse ou une personne du doigt — très irrespectueux.",
      "Accepter la nourriture ou les boissons offertes des deux mains, ou au moins de la main droite.",
      "L'île est pluriethnique (Hindous, Créoles, Musulmans, Sino-Mauriciens) — saluer dans la langue de l'interlocuteur est très apprécié.",
      "Éviter les démonstrations affectueuses trop publiques dans les zones rurales et les lieux de culte.",
    ],
    nature: [
      "Ne jamais marcher sur les barrières de corail dans le lagon — elles mettent des années à se former.",
      "Utiliser exclusivement de la crème solaire éco-responsable (sans oxybenzonate) pour préserver les coraux.",
      "Ne pas toucher, nourrir ni harceler la faune marine : tortues, dauphins, poissons — garder 2 m de distance.",
      "Ramasser ses déchets de plage — les plastiques dans le lagon ont un impact dévastateur sur l'écosystème.",
      "Respecter les zones de mouillage balisées — ne pas ancrer sur les coraux en kayak ou en bateau.",
    ],
  },

  // ── AFRIQUE DU SUD ─────────────────────────────────────────────────────────
  SOUTH_AFRICA: {
    flag: "🇿🇦",
    currency: "ZAR",
    lexique: [
      { word: "Howzit", translation: "Comment vas-tu ? (salut familier)", phonetic: "Hao-zit", lang: "Anglais SA" },
      { word: "Asseblief", translation: "S'il vous plaît", phonetic: "Ah-suh-bleef", lang: "Afrikaans" },
      { word: "Dankie", translation: "Merci", phonetic: "Dahn-kee", lang: "Afrikaans" },
      { word: "Lekker", translation: "Super / Délicieux / Sympa", phonetic: "Leh-ker", lang: "Anglais SA / Afrikaans" },
      { word: "Yebo", translation: "Oui (informel)", phonetic: "Yeh-boh", lang: "Zoulou" },
    ],
    pourboires: [
      { service: "Garde de parking", amount: "5–10 ZAR", note: "Omniprésents en ville — toujours payer" },
      { service: "Guide de safari", amount: "100–200 ZAR / jour", note: "Guide + ranger séparément" },
      { service: "Restaurant", amount: "10–15 %", note: "Standard, très apprécié" },
      { service: "Chauffeur", amount: "50–100 ZAR / jour", note: "Selon la durée de la sortie" },
      { service: "Porteur d'hôtel", amount: "20–30 ZAR", note: "Par bagage" },
    ],
    coutumes: [
      "Saluer chaleureusement avant toute transaction — 'Hello, how are you?' est une règle absolue.",
      "Demander l'autorisation avant de photographier des personnes, notamment dans les townships.",
      "Le hochement de tête ou la poignée de main accompagne toute salutation en milieu zoulou ou xhosa.",
      "L'Apartheid reste un sujet sensible — faire preuve d'empathie et éviter les généralisations.",
      "Rouler à gauche ! Le code de la route est différent de la France.",
    ],
    nature: [
      "Ne jamais descendre de votre véhicule dans une réserve ou un parc safari sans autorisation du ranger.",
      "Respecter les distances de sécurité avec le Big Five — éléphants et rhinocéros en particulier.",
      "Ne jamais nourrir les singes vervet ou les babouins — comportement agressif et amende possible.",
      "Rapporter tous ses déchets — beaucoup de parcs n'ont pas de poubelles sur les pistes.",
      "Ne pas acheter de produits à base d'ivoire, de corne de rhinocéros ou de peau de léopard — trafic illégal.",
    ],
  },

  // ── BOTSWANA ───────────────────────────────────────────────────────────────
  BOTSWANA: {
    flag: "🇧🇼",
    currency: "BWP",
    lexique: [
      { word: "Dumela", translation: "Bonjour (à une personne)", phonetic: "Doo-meh-la", lang: "Setswana" },
      { word: "Ke a leboga", translation: "Merci", phonetic: "Ke-ah-le-boh-ha", lang: "Setswana" },
      { word: "Ee / Nnyaa", translation: "Oui / Non", phonetic: "Eh / N-yaa", lang: "Setswana" },
      { word: "Go siame", translation: "D'accord / C'est bien", phonetic: "Go-syah-meh", lang: "Setswana" },
      { word: "Ke kae?", translation: "Combien ça coûte ?", phonetic: "Ke-kai", lang: "Setswana" },
    ],
    pourboires: [
      { service: "Guide safari / poler Okavango", amount: "100–150 BWP / jour", note: "Guide + poler séparément" },
      { service: "Restaurant", amount: "10 %", note: "Si service non inclus" },
      { service: "Chauffeur / transfert", amount: "50–100 BWP", note: "Pour les longues courses" },
      { service: "Personnel de lodge", amount: "Boîte commune", note: "Beaucoup de lodges ont une caisse partagée" },
      { service: "Porteur", amount: "20–30 BWP", note: "Par bagage" },
    ],
    coutumes: [
      "Serrer la main en posant la main gauche sur le poignet droit — signe de respect traditionnel.",
      "Ne pas se précipiter dans les discussions — une conversation commence toujours par les nouvelles et la famille.",
      "Dans les villages ruraux, demander la permission au chef avant toute visite ou photo.",
      "Offrir et recevoir des cadeaux à deux mains ou de la main droite soutenue de la gauche.",
      "Le respect des anciens est fondamental — laisser parler les personnes âgées en premier.",
    ],
    nature: [
      "Ne jamais quitter les pistes balisées dans le delta de l'Okavango — terrain marécageux et dangereux.",
      "Interdiction de nourrir ou d'approcher les hippopotames — animaux très dangereux malgré leur apparence.",
      "Ne pas ramasser plantes, coquillages ou éléments naturels dans les réserves.",
      "Respecter les distances avec la faune — éléphants, lions et léopards peuvent charger sans avertissement.",
      "Éviter toute lumière artificielle forte la nuit dans les camps — perturbation pour la faune nocturne.",
    ],
  },

  // ── MADAGASCAR ─────────────────────────────────────────────────────────────
  MADAGASCAR: {
    flag: "🇲🇬",
    currency: "MGA",
    lexique: [
      { word: "Manao ahoana", translation: "Bonjour (formel)", phonetic: "Mah-nao-ah-wona", lang: "Malagasy" },
      { word: "Misaotra", translation: "Merci", phonetic: "Mee-sao-tra", lang: "Malagasy" },
      { word: "Azafady", translation: "S'il vous plaît / Excusez-moi", phonetic: "Ah-zah-fah-dee", lang: "Malagasy" },
      { word: "Eny / Tsia", translation: "Oui / Non", phonetic: "Ay-ny / Tsee-ah", lang: "Malagasy" },
      { word: "Ohatrinona?", translation: "Combien ça coûte ?", phonetic: "Oh-ah-tree-noo-nah", lang: "Malagasy" },
    ],
    pourboires: [
      { service: "Guide", amount: "10 000–20 000 MGA / jour", note: "Revenu principal des guides locaux" },
      { service: "Chauffeur", amount: "5 000–10 000 MGA / jour", note: "Selon la distance parcourue" },
      { service: "Restaurant", amount: "Arrondir", note: "Culture du pourboire peu développée" },
      { service: "Porteur de trekking", amount: "5 000–8 000 MGA / jour", note: "Obligatoire dans certains parcs" },
      { service: "Personnel d'hébergement", amount: "Facultatif", note: "Toujours apprécié" },
    ],
    coutumes: [
      "Respecter les Fady (tabous locaux) — ils varient d'une région à l'autre et sont pris très au sérieux.",
      "Demander toujours la permission avant de photographier des personnes ou des villages.",
      "Apporter des cadeaux pratiques (cahiers, stylos) plutôt que de l'argent aux enfants des villages.",
      "Les salutations prolongées sont la norme — ne pas presser un échange de politesses.",
      "Éviter de toucher la tête des personnes, même des enfants — geste irrespectueux.",
    ],
    nature: [
      "Ne jamais acheter ou rapporter des lémuriens, caméléons ou animaux protégés — trafic sévèrement puni.",
      "Respecter strictement les limites des aires protégées — la déforestation est un problème grave.",
      "Ne pas allumer de feu en dehors des zones désignées — les forêts de Madagascar sont extrêmement fragiles.",
      "Éviter tout plastique jetable — les déchets sont un problème environnemental majeur dans l'île.",
      "Engager des guides locaux certifiés — soutient la conservation et les communautés.",
    ],
  },

  // ── RÉUNION ────────────────────────────────────────────────────────────────
  REUNION: {
    flag: "🇷🇪",
    currency: "EUR",
    lexique: [
      { word: "Bonzour / Bonjour", translation: "Bonjour", phonetic: "Bon-joor", lang: "Créole réunionnais / Français" },
      { word: "Ou lé koman ?", translation: "Comment vas-tu ?", phonetic: "Oo-lé-ko-man", lang: "Créole réunionnais" },
      { word: "Mèrsi amoin", translation: "Merci (créole)", phonetic: "Mair-see-ah-mwan", lang: "Créole réunionnais" },
      { word: "Amène azot", translation: "On y va ! (allons-y)", phonetic: "Ah-menn-ah-zot", lang: "Créole réunionnais" },
      { word: "Kombien ?", translation: "Combien ?", phonetic: "Kom-byan", lang: "Créole réunionnais" },
    ],
    pourboires: [
      { service: "Restaurant", amount: "Non obligatoire", note: "Un mot de remerciement sincère suffit souvent" },
      { service: "Guide de randonnée", amount: "5–10 €", note: "Pour les longues randonnées en cirques" },
      { service: "Chauffeur", amount: "Arrondir", note: "Non systématique" },
      { service: "Personnel d'hôtel", amount: "1–2 €", note: "Pour des services particuliers" },
      { service: "Taxi", amount: "Non obligatoire", note: "Prix fixés par compteur officiel" },
    ],
    coutumes: [
      "La Réunion est un DOM français — les codes de politesse sont similaires à la France métropolitaine.",
      "La culture créole valorise la convivialité et le partage — le maloya et la séga sont des arts de vivre.",
      "Participer aux fêtes locales (Diwali, Eid, Noël créole) si invité est très bien vécu.",
      "Apprendre quelques mots de créole réunionnais est toujours très bien reçu.",
      "Dans les marchés locaux, négocier légèrement est accepté, sans insistance.",
    ],
    nature: [
      "Respecter strictement les sentiers du Parc National — le cœur du parc est classé UNESCO.",
      "Ne jamais cueillir fleurs ou plantes endémiques dans les forêts primaires (Tamarins, Fanjans).",
      "En plongée, utiliser une crème solaire sans microplastiques dans le lagon de Saint-Leu.",
      "Ne pas perturber les nids de Pétrel de Barau et autres oiseaux endémiques en altitude.",
      "Respecter les conseils des guides pour les randonnées en Cirques — terrain imprévisible.",
    ],
  },

  // ── SÉNÉGAL ────────────────────────────────────────────────────────────────
  SENEGAL: {
    flag: "🇸🇳",
    currency: "XOF",
    lexique: [
      { word: "Nanga def ?", translation: "Comment vas-tu ?", phonetic: "Nan-ga-def", lang: "Wolof" },
      { word: "Maa ngi fi rekk", translation: "Je vais bien (réponse)", phonetic: "Mah-ngi-fi-rek", lang: "Wolof" },
      { word: "Jerejef", translation: "Merci", phonetic: "Jeh-reh-jef", lang: "Wolof" },
      { word: "Waaw / Deedeet", translation: "Oui / Non", phonetic: "Waow / Dee-det", lang: "Wolof" },
      { word: "Baal ma ak", translation: "Excusez-moi", phonetic: "Bahl-mah-ak", lang: "Wolof" },
    ],
    pourboires: [
      { service: "Guide", amount: "2 000–5 000 XOF / jour", note: "Revenu essentiel, très apprécié" },
      { service: "Chauffeur", amount: "1 000–2 000 XOF / jour", note: "Pour les longues courses" },
      { service: "Restaurant", amount: "10 %", note: "Dans les restaurants touristiques" },
      { service: "Vendeur de marché", amount: "Pas de pourboire", note: "Négocier est la coutume" },
      { service: "Porteur ou aide", amount: "500–1 000 XOF", note: "Selon le service rendu" },
    ],
    coutumes: [
      "La 'Teranga' (hospitalité) est sacrée — accepter la nourriture ou le thé offerts est un signe de respect.",
      "Toujours saluer longuement avant d'entrer dans le vif du sujet — les échanges de politesses sont valorisés.",
      "Utiliser la main droite pour manger, donner et recevoir des objets — la gauche est considérée impure.",
      "La négociation dans les marchés est une tradition — le premier prix est presque toujours à négocier.",
      "En zone rurale, demander la permission au chef de village avant toute photo.",
    ],
    nature: [
      "Ne jamais capturer ou acheter des tortues, des singes ou autres animaux protégés.",
      "Respecter les zones interdites des réserves ornithologiques (Djoudj, Delta du Saloum).",
      "Éviter les plastiques jetables — les plages sénégalaises souffrent de la pollution plastique.",
      "Dans les réserves, ne jamais quitter les pistes sans guide — faune et végétation sensibles.",
      "Soutenir la pêche artisanale locale — pilier de l'économie côtière.",
    ],
  },

  // ── KENYA ──────────────────────────────────────────────────────────────────
  KENYA: {
    flag: "🇰🇪",
    currency: "KES",
    lexique: [
      { word: "Jambo / Hujambo", translation: "Bonjour (formel)", phonetic: "Jam-bo / Hoo-jam-bo", lang: "Swahili" },
      { word: "Asante (sana)", translation: "Merci (beaucoup)", phonetic: "Ah-san-teh (sah-nah)", lang: "Swahili" },
      { word: "Tafadhali", translation: "S'il vous plaît", phonetic: "Tah-fah-dah-lee", lang: "Swahili" },
      { word: "Ndiyo / Hapana", translation: "Oui / Non", phonetic: "N-dee-yo / Hah-pah-nah", lang: "Swahili" },
      { word: "Bei gani?", translation: "Quel est le prix ?", phonetic: "Bay-gah-nee", lang: "Swahili" },
    ],
    pourboires: [
      { service: "Guide safari", amount: "10–15 USD / jour", note: "Norme internationale dans les lodges" },
      { service: "Chauffeur", amount: "5–10 USD / jour", note: "Séparé du guide" },
      { service: "Restaurant", amount: "10–15 %", note: "Dans les établissements touristiques" },
      { service: "Personnel de lodge", amount: "Boîte commune", note: "Demander le système en arrivant" },
      { service: "Porteur de randonnée", amount: "500–1 000 KES / jour", note: "Trekking / Kilimanjaro" },
    ],
    coutumes: [
      "'Habari?' (Comment ça va ?) est la salutation de base — répondre 'Nzuri' (bien) avec le sourire.",
      "Ne jamais photographier des Maasaï sans consentement explicite et sans rétribution.",
      "Retirer ses chaussures avant d'entrer dans une maison ou un lieu de prière.",
      "La ponctualité africaine est flexible — prévoir une marge de temps.",
      "Habillement couvrant recommandé dans les zones à majorité musulmane (côte, Mombasa).",
    ],
    nature: [
      "Interdiction absolue d'acheter de l'ivoire, des trophées de chasse ou produits issus d'espèces protégées.",
      "Respecter les règles des parcs — ne jamais quitter les véhicules sauf dans les zones autorisées.",
      "Ne pas nourrir ou approcher les animaux — même les girafes peuvent être dangereuses.",
      "Soutenir les conservancies communautaires plutôt que les fermes animalières non éthiques.",
      "Minimiser votre empreinte carbone — les safaris sont une source de revenus vitale pour les communautés.",
    ],
  },

  // ── JAPON ──────────────────────────────────────────────────────────────────
  JAPAN: {
    flag: "🇯🇵",
    currency: "JPY",
    lexique: [
      { word: "Konnichiwa", translation: "Bonjour", phonetic: "Kon-nee-chee-wah", lang: "Japonais" },
      { word: "Arigatou gozaimasu", translation: "Merci (poli)", phonetic: "Ah-ree-gah-toh go-zai-mas", lang: "Japonais" },
      { word: "Sumimasen", translation: "Excusez-moi / Pardon", phonetic: "Soo-mee-mah-sen", lang: "Japonais" },
      { word: "Onegaishimasu", translation: "S'il vous plaît (formel)", phonetic: "Oh-neh-gai-shee-mas", lang: "Japonais" },
      { word: "Ikura desu ka?", translation: "Combien ça coûte ?", phonetic: "Ee-koo-ra des-ka", lang: "Japonais" },
    ],
    pourboires: [
      { service: "Restaurant", amount: "0 %", note: "Pourboire considéré comme impoli — ne jamais laisser de monnaie" },
      { service: "Taxi", amount: "0 %", note: "Prix exact — ne pas laisser la monnaie en signe de tip" },
      { service: "Hôtel / Ryokan", amount: "Non applicable", note: "Service inclus dans le prix — concept de l'Omotenashi" },
      { service: "Guide privé", amount: "Facultatif", note: "Enveloppe discrète acceptable si vraiment satisfait" },
      { service: "Livreur / Artisan", amount: "0 %", note: "Jamais de pourboire — la qualité du travail se suffit" },
    ],
    coutumes: [
      "S'incliner légèrement pour saluer — plus l'inclinaison est profonde, plus elle est formelle.",
      "Ne jamais donner de pourboire — cela peut offenser (insulte implicite sur la qualité du service).",
      "Enlever ses chaussures avant d'entrer dans une maison, un ryokan ou un temple.",
      "Donner et recevoir cartes ou cadeaux avec les deux mains et un léger signe de tête.",
      "Parler bas dans les transports et mettre son téléphone en silencieux — règle absolue.",
    ],
    nature: [
      "Ramener ses déchets — les poubelles publiques sont rarissimes, même dans les parcs.",
      "Respecter les zones interdites aux visiteurs dans les temples et sanctuaires.",
      "Ne jamais nourrir les cerfs de Nara avec autre chose que les crackers officiels.",
      "Photographier dans certains sanctuaires est interdit — respecter les panneaux sans exception.",
      "En forêt, rester sur les sentiers balisés — les zones rurales 'Satoyama' sont habitats protégés.",
    ],
  },

  // ── THAÏLANDE ──────────────────────────────────────────────────────────────
  THAILAND: {
    flag: "🇹🇭",
    currency: "THB",
    lexique: [
      { word: "Sawasdee (krap/ka)", translation: "Bonjour (homme/femme)", phonetic: "Sah-wah-dee (krap/kah)", lang: "Thaï" },
      { word: "Khob khun", translation: "Merci", phonetic: "Kob-koon", lang: "Thaï" },
      { word: "Kho thot", translation: "Excusez-moi / Pardon", phonetic: "Kor-toht", lang: "Thaï" },
      { word: "Chai / Mai chai", translation: "Oui / Non", phonetic: "Chai / Mai-chai", lang: "Thaï" },
      { word: "Tao rai?", translation: "Combien ça coûte ?", phonetic: "Tao-rai", lang: "Thaï" },
    ],
    pourboires: [
      { service: "Restaurant", amount: "20–50 THB", note: "Ou 10–15 % dans les établissements avec service" },
      { service: "Massage", amount: "50–100 THB", note: "Après chaque séance, toujours apprécié" },
      { service: "Guide / Excursion", amount: "150–300 THB / jour", note: "Revenu important pour les guides" },
      { service: "Taxi / Tuk-tuk", amount: "Arrondir", note: "Pas obligatoire mais bien vu" },
      { service: "Hôtel / Porteur", amount: "20–50 THB", note: "Pour le portier ou le ménage" },
    ],
    coutumes: [
      "Pratiquer le 'Wai' (mains jointes, tête inclinée) pour saluer — très apprécié des Thaïlandais.",
      "Ne jamais toucher la tête d'une personne — c'est la partie la plus sacrée du corps.",
      "Tenue couvrant épaules et genoux obligatoire dans tous les temples — sarong disponible à l'entrée.",
      "La monarchie est sacrée — tout commentaire négatif sur la famille royale est illégal (lèse-majesté).",
      "Ne jamais croiser les jambes en pointant les pieds vers une statue de Bouddha ou une personne.",
    ],
    nature: [
      "Ne jamais participer à des 'expériences' avec éléphants impliquant des balades à dos — signe de maltraitance.",
      "Interdiction de toucher ou acheter des produits dérivés de faune protégée (coraux, tigres).",
      "Utiliser une crème solaire biodégradable lors des plongées en mer d'Andaman.",
      "Ne pas nourrir ni toucher les singes macaques — ils peuvent mordre et transmettent des maladies.",
      "Respecter les zones de non-pêche autour des récifs coraliens — essentiels pour leur régénération.",
    ],
  },

  // ── VIETNAM ────────────────────────────────────────────────────────────────
  VIETNAM: {
    flag: "🇻🇳",
    currency: "VND",
    lexique: [
      { word: "Xin chào", translation: "Bonjour", phonetic: "Sin-chao", lang: "Vietnamien" },
      { word: "Cảm ơn", translation: "Merci", phonetic: "Cam-on", lang: "Vietnamien" },
      { word: "Xin lỗi", translation: "Excusez-moi / Pardon", phonetic: "Sin-loy", lang: "Vietnamien" },
      { word: "Vâng / Không", translation: "Oui / Non", phonetic: "Vang / Khong", lang: "Vietnamien" },
      { word: "Bao nhiêu tiền?", translation: "Combien ça coûte ?", phonetic: "Bao-nyew-tyen", lang: "Vietnamien" },
    ],
    pourboires: [
      { service: "Restaurant", amount: "10–15 %", note: "De plus en plus répandu dans les villes" },
      { service: "Guide", amount: "100 000–200 000 VND / jour", note: "Revenu complémentaire essentiel" },
      { service: "Chauffeur / Xe om", amount: "50 000 VND", note: "Pour les longues courses en moto-taxi" },
      { service: "Hôtel / Porteur", amount: "50 000 VND", note: "Pour les services spéciaux" },
      { service: "Massage", amount: "50 000–100 000 VND", note: "Toujours apprécié après une séance" },
    ],
    coutumes: [
      "Sourire et saluer poliment, même si vous ne parlez pas la langue — très apprécié.",
      "S'habiller de manière couvrante pour visiter les pagodes — épaules et genoux couverts.",
      "Marchander est acceptable dans les marchés locaux, mais rester toujours courtois.",
      "Ne pas perdre la face — les conflits ouverts sont mal vus, privilégier les échanges calmes.",
      "Éviter de toucher ou d'embrasser un enfant sans autorisation des parents.",
    ],
    nature: [
      "Ne jamais acheter coraux, coquillages précieux ou animaux exotiques comme souvenirs (illégal).",
      "Dans la baie de Ha Long, respecter les zones de navigation et ne pas jeter de déchets à l'eau.",
      "Soutenir les treks chez l'habitant dans les minorités ethniques — préserver les cultures.",
      "Ne pas nourrir les animaux dans les parcs nationaux (Cat Ba, Phong Nha, Cuc Phuong).",
      "Réduire sa consommation de plastique — le Vietnam est très affecté par la pollution plastique marine.",
    ],
  },

  // ── MAROC ──────────────────────────────────────────────────────────────────
  MOROCCO: {
    flag: "🇲🇦",
    currency: "MAD",
    lexique: [
      { word: "As-salamu alaykum", translation: "Paix sur vous (bonjour formel)", phonetic: "As-sah-lah-moo-ah-lay-koom", lang: "Arabe marocain" },
      { word: "Shoukran", translation: "Merci", phonetic: "Shoo-kran", lang: "Arabe marocain" },
      { word: "Afak", translation: "S'il vous plaît", phonetic: "Ah-fak", lang: "Darija (arabe dialectal)" },
      { word: "Iyeh / La", translation: "Oui / Non", phonetic: "Ee-yeh / Lah", lang: "Arabe marocain" },
      { word: "Bshhal?", translation: "Combien ça coûte ?", phonetic: "Bsh-hahl", lang: "Darija" },
    ],
    pourboires: [
      { service: "Guide de médina", amount: "50–100 MAD", note: "Par demi-journée, à négocier à l'avance" },
      { service: "Restaurant", amount: "10 %", note: "Standard dans les établissements touristiques" },
      { service: "Porteur / hammam", amount: "10–20 MAD", note: "Pour les petits services rendus" },
      { service: "Gardien de parking", amount: "5–10 MAD", note: "Omniprésents dans les villes" },
      { service: "Chauffeur / Taxi", amount: "Arrondir", note: "Non obligatoire mais apprécié" },
    ],
    coutumes: [
      "Répondre 'Wa alaykum as-salam' quand on vous salue — signe de respect fondamental.",
      "Tenue couvrante dans les médinas, mosquées et zones rurales — surtout pour les femmes.",
      "Ne jamais entrer dans une mosquée en tant que non-musulman, sauf si explicitement autorisé.",
      "Accepter le thé à la menthe offert — refuser est perçu comme une offense.",
      "Négocier dans les souks est une tradition — mais avec respect et sans insolence.",
    ],
    nature: [
      "Ne jamais ramasser fossiles ou minéraux dans le Sahara ou les zones géologiques — très contrôlé.",
      "Respecter les oasis et palmeraies — ce sont des écosystèmes fragiles et vitaux.",
      "Éviter de camper sauvagement dans le désert sans guide — risque de désorientation.",
      "Ne pas alimenter les dromadaires ou singes avec autre chose que leur nourriture naturelle.",
      "Ramener ses déchets des excursions désertiques — les vents répandent les plastiques dans tout l'écosystème.",
    ],
  },

  // ── INDONÉSIE ──────────────────────────────────────────────────────────────
  INDONESIA: {
    flag: "🇮🇩",
    currency: "IDR",
    lexique: [
      { word: "Selamat pagi", translation: "Bonjour (matin)", phonetic: "Suh-lah-mat-pah-gee", lang: "Indonésien" },
      { word: "Terima kasih", translation: "Merci", phonetic: "Tuh-ree-mah-kah-see", lang: "Indonésien" },
      { word: "Permisi", translation: "Excusez-moi", phonetic: "Pehr-mee-see", lang: "Indonésien" },
      { word: "Ya / Tidak", translation: "Oui / Non", phonetic: "Yah / Tee-dak", lang: "Indonésien" },
      { word: "Berapa harganya?", translation: "Combien ça coûte ?", phonetic: "Buh-rah-pah har-gah-nyah", lang: "Indonésien" },
    ],
    pourboires: [
      { service: "Restaurant", amount: "10–15 %", note: "Ou laisser la petite monnaie" },
      { service: "Guide Bali / Java", amount: "50 000–100 000 IDR", note: "Par demi-journée d'excursion" },
      { service: "Chauffeur", amount: "50 000–100 000 IDR / jour", note: "Revenu important" },
      { service: "Instructeur surf", amount: "50 000 IDR", note: "Après la session" },
      { service: "Personnel d'hébergement", amount: "Facultatif", note: "Quelques milliers de roupies pour le ménage" },
    ],
    coutumes: [
      "Porter un sarong et une écharpe à la taille pour entrer dans les temples balinais — fournis à l'entrée.",
      "Ne jamais entrer dans un temple lors des menstruations — règle strictement observée à Bali.",
      "Utiliser la main droite pour donner et recevoir nourriture et objets.",
      "Ne jamais toucher la tête des personnes, notamment des enfants.",
      "Participer avec respect aux cérémonies religieuses si invité — ne pas interrompre.",
    ],
    nature: [
      "Ne jamais toucher ou casser les récifs coraliens lors des plongées ou snorkeling.",
      "Interdiction de nourrir les singes sacrés (Ubud, Sangeh) — comportement agressif et maladies.",
      "Ne pas acheter de produits à base de tortues marines — espèce protégée.",
      "Ramener ses déchets des randonnées sur les volcans (Batur, Agung).",
      "Respecter les zones marines protégées (Komodo, Raja Ampat) — ne pas pêcher dans ces zones.",
    ],
  },

  // ── INDE ───────────────────────────────────────────────────────────────────
  INDIA: {
    flag: "🇮🇳",
    currency: "INR",
    lexique: [
      { word: "Namaste", translation: "Bonjour / Salut respectueux (universel)", phonetic: "Nah-mas-tay", lang: "Hindi" },
      { word: "Shukriya", translation: "Merci (informel)", phonetic: "Shoo-kree-yah", lang: "Hindi / Ourdou" },
      { word: "Maafi kijiye", translation: "Excusez-moi (formel)", phonetic: "Mah-fee-kee-jee-yeh", lang: "Hindi" },
      { word: "Haan / Nahin", translation: "Oui / Non", phonetic: "Haan / Na-hin", lang: "Hindi" },
      { word: "Kitne ka hai?", translation: "Combien ça coûte ?", phonetic: "Kit-neh-kah-hay", lang: "Hindi" },
    ],
    pourboires: [
      { service: "Restaurant", amount: "10 %", note: "Norme dans les établissements touristiques" },
      { service: "Guide / Chauffeur", amount: "200–500 INR / jour", note: "Revenu complémentaire important" },
      { service: "Porteur (gare / aéro)", amount: "50–100 INR", note: "Standard selon le nombre de bagages" },
      { service: "Taxi / Rickshaw", amount: "Arrondir", note: "Pas obligatoire" },
      { service: "Personnel de temple", amount: "50–100 INR", note: "Pour les services liés aux cérémonies" },
    ],
    coutumes: [
      "Saluer avec les mains jointes et un léger 'Namaste' — applicable partout et à tous.",
      "Retirer ses chaussures avant d'entrer dans un temple, une mosquée ou une maison.",
      "Éviter le contact physique avec des femmes inconnues — sauf poignée de main si elles l'initient.",
      "La vache est sacrée dans l'hindouisme — ne jamais la déranger ni faire de commentaire négatif.",
      "Accepter la nourriture ou les offrandes de la main droite uniquement.",
    ],
    nature: [
      "Ne jamais nourrir les singes dans les temples et réserves — agressivité et maladies transmissibles.",
      "Respecter les règles strictes des sanctuaires (tigres, éléphants) — safari réglementé uniquement.",
      "Interdiction de toucher les espèces protégées dans les parcs nationaux (tigres, léopards, rhinocéros).",
      "Éviter d'acheter coraux, coquillages précieux ou ambre dans les marchés côtiers.",
      "Dans le Gange et les lieux sacrés — respecter leur sacralité et éviter tout geste irrespectueux.",
    ],
  },

  // ── PAR DÉFAUT ─────────────────────────────────────────────────────────────
  DEFAULT: {
    flag: "🌍",
    currency: "",
    lexique: [
      { word: "Bonjour / Hello", translation: "Salutation universelle, toujours bienvenue", phonetic: "Bon-joor / Heh-loh", lang: "Français / Anglais" },
      { word: "S'il vous plaît / Please", translation: "Formule de politesse fondamentale", phonetic: "Seel-voo-play / Pleez", lang: "Français / Anglais" },
      { word: "Merci / Thank you", translation: "Exprimer sa gratitude dans n'importe quelle langue", phonetic: "Mair-see / Tank-yoo", lang: "Français / Anglais" },
      { word: "Combien ? / How much?", translation: "Indispensable dans les marchés locaux", phonetic: "Kom-byan / Hao-match", lang: "Français / Anglais" },
      { word: "Excusez-moi / Excuse me", translation: "Pour attirer l'attention poliment", phonetic: "Ex-koo-zay-mwah / Ex-kyooz-mee", lang: "Français / Anglais" },
    ],
    pourboires: [
      { service: "Restaurant", amount: "10–15 %", note: "Standard international — vérifier si service inclus" },
      { service: "Guide / Excursion", amount: "10–20 € / jour", note: "Selon la durée et la qualité de la visite" },
      { service: "Taxi / Chauffeur", amount: "Arrondir", note: "À la dizaine supérieure en monnaie locale" },
      { service: "Hôtel / Porteur", amount: "1–2 € / bagage", note: "Monnaie locale de préférence" },
      { service: "Spa / Massage", amount: "10–15 %", note: "Si service non inclus" },
    ],
    coutumes: [
      "Se renseigner sur les coutumes locales avant d'arriver — chaque pays a ses propres codes de conduite.",
      "Saluer en premier, même brièvement, est perçu positivement dans la très grande majorité des cultures.",
      "Demander systématiquement la permission avant de photographier des personnes.",
      "Respecter les codes vestimentaires locaux, particulièrement dans les lieux de culte.",
      "Apprendre quelques mots dans la langue locale est le signe de respect le plus apprécié au monde.",
    ],
    nature: [
      "Appliquer le principe 'Leave No Trace' — ne jamais laisser de déchets dans la nature.",
      "Respecter les zones protégées et les sentiers balisés — ne jamais créer de nouveaux chemins.",
      "Ne jamais ramasser de souvenirs naturels (coquillages, pierres, plantes) dans les réserves.",
      "Ne jamais nourrir les animaux sauvages — cela perturbe leurs comportements et peut être dangereux.",
      "Privilégier les opérateurs éco-responsables locaux — votre choix a un impact direct sur la préservation.",
    ],
  },
};

export function getCultureData(destination = "") {
  const country = detectCountry(destination);
  return CULTURE_DATA[country] || CULTURE_DATA.DEFAULT;
}
